import axios, { AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';

import { API_BASE_URL, API_TIMEOUT } from '../config';


export class BaseRepository {
    api: AxiosInstance
    
    constructor() {
        this.api = axios.create({
            baseURL: API_BASE_URL,
            timeout: API_TIMEOUT,
            withCredentials: true
        });
        
        axiosRetry(this.api, {
            retries: 5,
            retryDelay: axiosRetry.exponentialDelay,
            retryCondition: (error) => {
                return axiosRetry.isNetworkError(error);
            }
        });
    }
};